import React from 'react';
import PropTypes from 'prop-types';
import { EventDetailProvider } from '../../../icsc-app/js/components/pages/MyIcsc/Events/EventDetailProvider';
import LoadingArea from '../../../_shared-react/components/_molecules/LoadingArea';
import useEvent from '../../../icsc-app/js/hooks/useEvent';

/**
 * Context Provider: SessionsDetailProvider
 * Orchestrates the fetching of event-level data and provides it
 * to the session-related components.
 */
const SessionsDetailProvider = ({ children, eventCode }) => {
    const event = useEvent(eventCode);

    if (event === null) {
        return <LoadingArea />;
    }

    // Use Object.keys check to ensure we actually have data payload
    const hasEventData = event && Object.keys(event).length > 0;

    if (!hasEventData) {
        return (
            <div className="text-center py-5">
                <p className="mb-0">
                    No event or schedule found for: <strong>{eventCode}</strong>.
                </p>
            </div>
        );
    }

    return (
        <EventDetailProvider.Provider
            value={{
                defaultView: 'sessions',
                event,
                eventSlug: eventCode,
            }}
        >
            {children}
        </EventDetailProvider.Provider>
    );
};

SessionsDetailProvider.propTypes = {
    children: PropTypes.node.isRequired,
    eventCode: PropTypes.string,
};

export default SessionsDetailProvider;
